import { useContext, useEffect, useState } from 'react';
import bem from '../../../utils/bem';
import { FapAppContext } from '../../../context/fap-app.context';
import { appHomePage } from '../../../config/fapApp.config';
import Input from '../../../Components/Atoms/FormComponents/Input';
import ProcessCard from '../../../Components/Molecules/Cards/ProcessCard';
import GooglePlacesAuto from '../../../Components/Molecules/GooglePlacesAuto';
import ProcessSteps from '../../../Components/Molecules/ProcessSteps';
import {
  projectDetailsProvidedEvent,
  projectDetailsLoaded,
} from '../../../utils/analitic.utils';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import { useLocation } from '../../../context/location.context';
import geocodeByPlaceId from '../../../utils/geocodeByPlaceId';
import Link from '../../../Components/Atoms/Link';

function fapFormSelectionEmitter(action) {
  const event = new CustomEvent('fap:contact-form', {
    detail: {
      action,
    },
  });
  window.dispatchEvent(event);
}

const FapHomePage = () => {
  const {
    categories,
    selectedCategory,
    setSelectedCategory,
    selectedLocation,
    setSelectedLocation,
    commonSettings,
    setContractorsTray,
  } = useContext(FapAppContext);
  const { locationState } = useLocation();
  const [selectedContractor, setSelectedContractor] = useState(false);
  const [selectedAgree, setSelectedAgree] = useState(false);
  const [initialCategory, setInitialCategory] = useState(null);
  const [initialLocation, setInitialLocation] = useState(null);

  let selectedCategoryFlag = !!selectedCategory;
  let selectedLocationFlag = !!selectedLocation;
  const termLink = '/terms-and-conditions-where-buy/find-pro/get-quote';

  const prodCategoryUpdated = new CustomEvent('fap:prodCategoryUpdated', {
    detail: { key: '_ct_app_fap_prod_category' },
  });

  const locationUpdated = new CustomEvent('fap:locationUpdated', {
    detail: { key: '_ct_app_fap_geo' },
  });
  const updateSteps = (i, value) => {
    const stepValue = value !== undefined ? value : true;
    switch (i) {
      case 0:
        selectedCategoryFlag = stepValue;
        break;
      case 1:
        selectedLocationFlag = stepValue;
        break;
      case 2:
        setSelectedContractor(stepValue);
        break;
      case 3:
        setSelectedAgree(stepValue);
        break;
      default:
        selectedCategoryFlag = false;
        selectedLocationFlag = false;
        setSelectedContractor(false);
        setSelectedAgree(false);
    }

    if (i === 0) {
      window.dispatchEvent(prodCategoryUpdated);
    }

    if (i === 1) {
      window.dispatchEvent(locationUpdated);
    }
  };

  useEffect(() => {
    if (!locationState?.zip?.length > 0) {
      setSelectedLocation(null);
      updateSteps(1, false);
    }
  }, [locationState]);

  useEffect(() => {
    if (locationState.placeId) {
      geocodeByPlaceId(locationState.placeId)
        .then((res) => {
          setSelectedLocation(res);
          updateSteps(1);
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error(error));
    }
  }, [locationState.placeId]);
  useEffect(() => {
    if (!initialCategory) {
      const oldCategory = selectedCategory?.label;
      setInitialCategory(oldCategory);
    }
    if (!initialLocation) {
      const oldLocation = selectedLocation?.[0]?.formatted_address;
      setInitialLocation(oldLocation);
    }
  }, []);
  const pushAnalyticsEvent = useAnalyticsPushEvent();
  const analyticsContentType = 'find_a_pro';
  const [contractorAction, setContractorAction] = useState(null);
  // Use this effect to set Product category if it passed by params.
  useEffect(() => {
    if (window.location.search.includes('product_category')) {
      const windowParams = new URL(document.location).searchParams;
      const prodCat = windowParams.get('product_category');
      const productCatPointer =
        commonSettings.product_category_to_product_options.find(
          (pointer) => pointer.split('|')[0] === prodCat,
        );
      if (productCatPointer) {
        const catLabel = productCatPointer.split('|')[1];
        if (catLabel) {
          const newCat = categories.find((item) => item.label === catLabel);
          setSelectedCategory(newCat);
        }
      }
    }
  }, []);

  useEffect(() => {
    pushAnalyticsEvent(
      projectDetailsLoaded({
        contentType: 'find_a_pro',
        productCategory: selectedCategory?.label,
        location: selectedLocation,
      }),
    );
  }, []);

  useEffect(() => {
    updateSteps(2, false);

    const onPageShowHandler = (event) => {
      setContractorAction(null);
      updateSteps(2, false);
      if (event.persisted) {
        // Force a reload page to update contractor select in bfcache.
        document.location.reload();
      }
    };
    window.addEventListener('pageshow', onPageShowHandler);

    return () => {
      window.removeEventListener('pageshow', onPageShowHandler);
    };
  }, []);

  const componentClassName = 'fap-home-page';

  const onCategorySelectHandler = (category) => {
    setSelectedCategory(category);
    updateSteps(0);
    pushAnalyticsEvent(
      projectDetailsProvidedEvent({
        contentType: analyticsContentType,
        filterName: 'product',
        filterValue: category.label,
      }),
    );
  };
  const onLocationSelectHandler = (location) => {
    setSelectedLocation(location);
    updateSteps(1);
    pushAnalyticsEvent(
      projectDetailsProvidedEvent({
        contentType: analyticsContentType,
        filterName: 'location',
        filterValue: location?.[0]?.formatted_address,
      }),
    );
  };
  const onContractorSelectHandler = (opt) => {
    if (opt === 'contact') {
      fapFormSelectionEmitter('show');
      pushAnalyticsEvent({
        event: 'form_opened',
        event_origin: 'front_end',
        form_name: 'find_a_pro_contact_me',
      });
      setContractorsTray([]);
    }
    if (opt === 'search') {
      if (
        initialCategory !== selectedCategory?.label ||
        initialLocation !== selectedLocation?.[0]?.formatted_address
      ) {
        setContractorsTray([]);
      }
      fapFormSelectionEmitter('hide');
      updateSteps(2);
    }
    setContractorAction(opt);
    updateSteps(3, false);
    pushAnalyticsEvent({
      event: 'contact_method_selected',
      event_origin: 'front_end',
      content_type: 'find_a_pro',
      method: opt === 'contact' ? 'CT_initiated' : 'user_initiated',
      vendor_type: 'contractor',
    });
  };
  const onContractorAgreementHandler = (event) => {
    updateSteps(3, event.target.checked);
    if (event.target.checked === true) {
      setContractorAction('agreed');
    }
  };
  const allStepsPassed = () =>
    ![
      !!selectedCategoryFlag,
      !!selectedLocationFlag,
      selectedContractor,
      selectedAgree,
    ].includes(false);

  return (
    <div className="container">
      <div className={bem(componentClassName)}>
        <div className={bem('cards', [], componentClassName)}>
          {categories && categories.length > 0 && (
            <ProcessCard
              completed={selectedCategory}
              title={Drupal.t('Product')}
              className={bem('card', [], componentClassName)}
              tooltip={commonSettings.home_product_tooltip}
            >
              <h4 className={bem('card-title', [], componentClassName)}>
                {Drupal.t('I need...')}
              </h4>
              <fieldset
                className={bem('card-options', ['in-cols'], componentClassName)}
              >
                <legend className="visually-hidden">
                  {Drupal.t('Please select a product.')}
                </legend>
                {categories.map((product) => (
                  <Input
                    key={product.label}
                    type="radio"
                    name="product"
                    value={product.value}
                    extraInput={['small']}
                    extraLabel={bem('card-option', [], componentClassName)}
                    onChange={() => onCategorySelectHandler(product, 0)}
                    checked={
                      selectedCategory &&
                      selectedCategory.label === product.label
                    }
                  >
                    {product.label}
                  </Input>
                ))}
              </fieldset>
            </ProcessCard>
          )}
          <ProcessCard
            title={Drupal.t('Location')}
            className={bem('card', [], componentClassName)}
            completed={selectedLocation}
            tooltip={commonSettings.home_location_tooltip}
          >
            <h4 className={bem('card-title', [], componentClassName)}>
              {Drupal.t('Doing a project in...')}
            </h4>
            <GooglePlacesAuto
              inputDefaultValue={selectedLocation?.[0]?.formatted_address}
              onPlaceSelected={(l) => onLocationSelectHandler(l)}
            />
          </ProcessCard>
          <ProcessCard
            title={Drupal.t('Contractor Selection')}
            className={bem('card', [], componentClassName)}
            completed={contractorAction}
            tooltip={commonSettings.home_contractor_settings_tooltip}
          >
            <h4 className={bem('card-title', [], componentClassName)}>
              {Drupal.t('I want to…')}
            </h4>
            <fieldset className={bem('card-options', [], componentClassName)}>
              <legend className="visually-hidden">
                {Drupal.t('Please select a product.')}
              </legend>
              <Input
                type="radio"
                name="request-type"
                value="search"
                extraInput={['small']}
                checked={
                  contractorAction === 'search' || contractorAction === 'agreed'
                }
                onChange={() => onContractorSelectHandler('search')}
                extraLabel={bem('card-option', [], componentClassName)}
              >
                {Drupal.t('Find a contractor myself')}
              </Input>
              <Input
                type="radio"
                name="request-type"
                value="contact"
                checked={contractorAction === 'contact'}
                extraInput={['small']}
                onChange={() => onContractorSelectHandler('contact')}
                extraLabel={bem('card-option', [], componentClassName)}
              >
                {Drupal.t('Have CertainTeed contractors contact me*')}
              </Input>
              {contractorAction === 'contact' && (
                <p className={bem('disclaimer', [], componentClassName)}>
                  {commonSettings.home_contractor_selection}
                </p>
              )}
            </fieldset>
          </ProcessCard>
        </div>
        {contractorAction !== 'contact' && (
          <div className={bem('legal', [], componentClassName)}>
            <Input
              type="checkbox"
              name="agree"
              value="agreed"
              checked={selectedAgree}
              onChange={onContractorAgreementHandler}
            >
              {Drupal.t('I Have Read And Agree to The ')}
              <Link url={termLink}>{Drupal.t('Terms & Conditions')}</Link>
            </Input>
          </div>
        )}
        {!allStepsPassed() && contractorAction !== 'contact' && (
          <>
            <p
              className={bem('process-msg', [], componentClassName, [
                'h',
                'h6',
              ])}
            >
              {Drupal.t('Fill out the above in order to move forward')}
            </p>
            <div className={bem('steps', [], componentClassName)}>
              <ProcessSteps
                steps={[
                  !!selectedCategoryFlag,
                  !!selectedLocationFlag,
                  selectedContractor,
                  selectedAgree,
                ]}
              />
            </div>
          </>
        )}
        {allStepsPassed() && contractorAction === 'agreed' && (
          <a
            href={`${appHomePage}/results`}
            className={[bem('cta', [], componentClassName, ['btn'])]}
          >
            {Drupal.t('See contractor results')}
          </a>
        )}
      </div>
    </div>
  );
};

export default FapHomePage;
